import React, { Component, Fragment } from 'react';
import { Button, ViewportManager, viewports } from 'luna-react';
import Table from '../Table';
import Disclaimer from '../Disclaimer';
import Sparkline from '../Sparkline';
import {
  toLocaleCurrencyString,
  toLocaleNumericString,
  getValueSign,
  getValueVectorSybmol,
} from '../Shared/utils';

class CoinTable extends Component {
  state = {
    isMobileViewport: true,
  }

  getTopTableColumns = () => {
    const { baseCurrencySymbol } = this.props;
    const { isMobileViewport } = this.state;

    const allColumns = [
      {
        name: 'No.',
        className: 'flexible-table__cell--left flexible-table__cell--xsmall',
        key: 'market_cap_rank',
        rawValue({ market_cap_rank }) {
          return parseInt(market_cap_rank, 10);
        },
      },
      {
        name: '',
        sortable: false,
        className: [
          'flexible-table__cell--center',
          'flexible-table__cell--no-padding',
          'flexible-table__cell--xsmall',
          'top10Table__coinSymbol',
        ].join(' '),
        render({ image, name }) {
          return <img loading="lazy" src={image} alt={`${name} logo`} width="20" height="20" />;
        },
      },
      {
        className: 'flexible-table__cell--center flexible-table__cell--small',
        name: 'Code',
        key: 'symbol',
      },
      {
        className: 'flexible-table__cell--left',
        name: 'Name',
        rawValue({ name }) {
          return name;
        },
        render({ name, pageLink }) {
          return <a href={pageLink}>{name}</a>;
        },
      },
      {
        className: 'flexible-table__cell--right flexible-table__cell--large',
        name: 'Price',
        rawValue({ current_price }) {
          return parseFloat(current_price);
        },
        render({ rawValue: value }) {
          return toLocaleCurrencyString({
            currencySymbol: baseCurrencySymbol,
            fractionDigits: 4,
            value,
          });
        },
      },
      {
        name: '',
        className: 'flexible-table__cell--center flexible-table__cell--small',
        sortable: false,
        render({ pageLink }) {
          return <Button label="Buy" link={pageLink} modifiers="success small" />;
        },
      },
      {
        name: 'Circulating Supply',
        className: 'flexible-table__cell--right top10Table__darkCell flexible-table__cell--large',
        hideOnMobile: true,
        rawValue({ circulating_supply }) {
          return parseInt(circulating_supply, 10);
        },
        render({ rawValue: value }) {
          return toLocaleNumericString({ value, fractionDigits: 0 });
        },
      },
      {
        name: 'Market Cap',
        className: 'flexible-table__cell--right top10Table__darkCell flexible-table__cell--xlarge',
        hideOnMobile: true,
        rawValue({ market_cap }) {
          return parseInt(market_cap, 10);
        },
        render({ rawValue: value }) {
          return toLocaleCurrencyString({
            currencySymbol: baseCurrencySymbol,
            fractionDigits: 0, // FIXME: make it working
            value,
          })
          .replace('.00', ''); // FIXME: don't use this one
        },
      },
      {
        name: 'Change (24H)',
        className: 'flexible-table__cell--right top10Table__darkCell flexible-table__cell--medium',
        hideOnMobile: true,
        rawValue({ price_change_percentage_24h }) {
          return parseFloat(price_change_percentage_24h);
        },
        render({ rawValue }) {
          const sign = getValueSign(rawValue);
          const value = toLocaleNumericString({
            value: Math.abs(rawValue),
            fractionDigits: 2,
          });

          return (
            <strong data-sign={sign}>{value}%</strong>
          )
        },
      },
      {
        name: '+/- (24H)',
        className: 'flexible-table__cell--right top10Table__darkCell flexible-table__cell--large',
        hideOnMobile: true,
        rawValue({ price_change_percentage_24h, current_price }) {
          const percentValue24h = 100 + parseFloat(price_change_percentage_24h);
          const currentPrice = parseFloat(current_price);
          const price24h = currentPrice * 100 / percentValue24h;

          return currentPrice - price24h;
        },
        render({ rawValue }) {
          const symbol = getValueVectorSybmol(rawValue);
          const value = toLocaleCurrencyString({
            currencySymbol: baseCurrencySymbol,
            value: Math.abs(rawValue),
          });

          return (
            <strong data-symbol={symbol}>{value}</strong>
          )
        },
      },
      {
        name: 'Volume (24H)',
        className: 'flexible-table__cell--right top10Table__darkCell flexible-table__cell--xxlarge',
        hideOnMobile: true,
        rawValue({ total_volume }) {
          return parseFloat(total_volume);
        },
        render({ rawValue: value }) {
          return toLocaleCurrencyString({
            currencySymbol: baseCurrencySymbol,
            fractionDigits: 0,
            value,
          })
          .replace('.00', ''); // FIXME: don't use this one;
        },
      },
      {
        name: 'Price graph (7D)',
        className: 'top10Table__graph top10Table__darkCell flexible-table__cell--xlarge ',
        sortable: false,
        hideOnMobile: true,
        render({ sparkline_in_7d }) {
          return <Sparkline data={sparkline_in_7d.price} />
        },
      },
    ];

    return isMobileViewport ? allColumns.filter(column => !column.hideOnMobile) : allColumns;
  }

  updateViewport = ({ windowWidth }) => {
    const isMobileViewport = windowWidth < viewports.medium;
    this.setState({ isMobileViewport });
  };

  render() {
    const { topCoins, baseCurrencySymbol, lastUpdateDateString } = this.props;

    const columns = this.getTopTableColumns();

    return (
      <Fragment>
        <ViewportManager onWindowWidthChange={this.updateViewport} />
        <Table rows={topCoins} columns={columns} baseCurrencySymbol={baseCurrencySymbol} />
        <Disclaimer lastUpdateDateString={lastUpdateDateString} />
      </Fragment>
    );
  }
}

export default CoinTable;



// WEBPACK FOOTER //
// ./src/CoinTable/index.js